import {Action} from '@ngrx/store';
import {type} from '../../shared';


export const conceptOrderLoadActionTypes = {
  LOAD: type('[Concept order] LOAD'),
  LOAD_SUCCESS: type('[Concept order] LOAD Success'),
  LOAD_FAIL: type('[Concept order] LOAD Fail'),
  CLEAR: type('[Concept order] Clear'),
};

export class LoadConceptOrderAction implements Action {
  readonly type = conceptOrderLoadActionTypes.LOAD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class LoadSuccessConceptOrderAction implements Action {
  readonly type = conceptOrderLoadActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class LoadConceptOrderFailAction implements Action {
  readonly type = conceptOrderLoadActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class LoadConceptOrderClearAction implements Action {
  readonly type = conceptOrderLoadActionTypes.CLEAR;
  constructor() {}
}
